import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { cookiesTool } from 'react-gdpr'

import { actions } from '../../redux'
import { actions as TrackingActions } from '../../redux/tracking/redux'
import { catchExternalLinks } from '../../utils/TrackingUtils'

export const Tracker = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    if (cookiesTool.isActive('analytics')) {
      dispatch(TrackingActions.enableTracking())
    }

    catchExternalLinks((link: string) => {
      dispatch(
        TrackingActions.trackEvent({
          action: link,
          category: 'Liens Sortants',
          label: document.location.pathname + document.location.search,
        })
      )
    })
  }, [dispatch])

  useEffect(() => {
    dispatch(actions.tracking.trackPage({ path: location.pathname }))
  }, [dispatch, location])

  return null
}
